import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableCashier from 'views/betShopManagement/cashier/tableCashier'; // Importing TableCashier component
import BetShopCashierAdvertesing from 'views/betShopManagement/cashier/betShopAdvertising'; // Importing BetShopCashierAdvertesing component
import BetShopCashierAdvertesingCashier from 'views/betShopManagement/cashier/betShopAdvertisingCashier'; // Importing BetShopCashierAdvertesingCashier component
import BetShopComissions from 'views/betShopManagement/cashier/betShopComissions'; // Importing BetShopComissions component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the cashier view for the bet shop.
 * @extends JetView
 */
export default class betShopCashierView extends JetView {
    /**
     * Configures the layout of the cashier view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            // First toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Pager ID
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };
        const toolbar2 = {
            // Second toolbar configuration (duplicate of the first)
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Pager ID (duplicate)
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size (duplicate)
                },
            ],
        };
        const left = {
            // Left panel configuration
            responsiveCell: false,
            paddingX: 15,
            paddingY: 10,
            css: 'cajeros',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion view for collapsible sections
                    css: 'comission',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            label: _('Cajeros'), // Section label
                            header: _('Cajeros'), // Section header
                            body: {
                                rows: [
                                    {
                                        padding: 5,
                                        height: 50,
                                        cols: [
                                            {},
                                            {
                                                view: 'button', // Button to add cashier
                                                value: _('Añadir Cajero'),
                                                type: 'form',
                                                hidden: !devConfig.getPermAction(
                                                    'betShopCashierAdd',
                                                    'Add', // Permission check for adding cashier
                                                ),
                                                css: 'prm-betShopCashierAdd',
                                                width: 150,
                                                click: () => {
                                                    // Click event for adding cashier
                                                    this.app.callEvent('addCashie:button', [[]]);
                                                },
                                            },
                                            {
                                                view: 'button', // Button to consult cashier
                                                value: _('Consultar'),
                                                type: 'form',
                                                width: 150,
                                                click: () => {
                                                    // Click event for consulting cashier
                                                    this.app.callEvent('cashier:filter', [[]]);
                                                },
                                            },
                                        ],
                                    },
                                    TableCashier, // TableCashier component
                                    toolbar, // First toolbar
                                ],
                            },
                        },
                    ],
                },
                BetShopCashierAdvertesingCashier, // BetShopCashierAdvertesingCashier component
                BetShopCashierAdvertesing, // BetShopCashierAdvertesing component
            ],
        };
        return {
            // Return the main configuration object
            view: 'form',
            type: 'wide',
            responsive: true,
            scroll: true,
            rows: [left], // Main layout rows
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Wait for Webix to be ready
            webix.attachEvent('onRotate', function (orientation) {
                // Event listener for device rotation
                window.location.reload(); // Reload the page on rotation
            });
        });
    }
}

// FILE DOCUMENTED
